import {useEffect, useState} from "react";

export const schedulerRecent = (coverage, now = Date.now()) => {
  if (!coverage?.scheduler_configured || coverage.scheduler_recent !== true) return false;
  const raw = coverage.last_scheduler_ping_at;
  const stamp = typeof raw === "string" && raw.includes(":") ? Date.parse(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(raw) ? raw : `${raw}Z`) : NaN;
  return Number.isFinite(stamp) && now >= stamp && now - stamp <= 1800000;
};

export const integrationFreshness = (integration, now = Date.now()) => {
  if (integration?.status !== "connected") return "disconnected";
  if (!["int-gmail", "int-gcal"].includes(integration.id)) return integration.sync_state;
  const raw = integration.last_sync;
  if (!raw) return "never";
  // Interpret legacy timestamps without an offset as UTC, just like the server.
  const timestamp = typeof raw === "string" && raw.includes(":")
    ? Date.parse(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(raw) ? raw : `${raw}Z`) : NaN;
  if (!Number.isFinite(timestamp)) return "unknown";
  const age = now - timestamp;
  const limit = (integration.sync_max_age_seconds || (integration.id === "int-gmail" ? 10800 : 86400)) * 1000;
  if (age < 0) return "future";
  if (age > limit) return "stale";
  // Never upgrade a server-side warning based only on the phone's clock.
  return integration.sync_state === "fresh" ? "fresh" : integration.sync_state || "unknown";
};

export const useFreshnessClock = () => {
  const [, setNow] = useState(Date.now);
  useEffect(() => {
    const tick = () => setNow(Date.now());
    const timer = window.setInterval(tick, 60000);
    window.addEventListener("focus", tick);
    document.addEventListener("visibilitychange", tick);
    return () => {window.clearInterval(timer);window.removeEventListener("focus",tick);document.removeEventListener("visibilitychange",tick);};
  }, []);
  // A response may be newer than the mount-time tick. Compare with the actual
  // render time so a just-completed sync is not briefly labelled "future".
  return Date.now();
};
